module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Electric/Hair-dryer-7279c9d2a7825de98337942bb8cdb064.svg";